export const CONTENT = '소식';

export const TICKET = '서비스';

export const PLAN = '구독권';
